import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import auth from './reducer-auth';
import company from './reducer-company';
import engine from './reducer-engine';
import engine1 from './reducer-engine1';
import test from './reducer-test';
import test1 from './reducer-test1';
import timer from './reducer-timer';

const rootReducer = combineReducers({
  form,
  company,
  auth,
  test,
  test1,
  engine,
  engine1,
  timer,
});

export default rootReducer;
